import { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { useSearchParams } from "react-router-dom";
import { IDoctorSpecialty } from "../../../providers/doctorsData/types";
import { IAllSpecsModal } from "./types";


export const AllSpecsModal = ({ modal, closeModal, specs }: IAllSpecsModal) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [filterList, setFilterList] = useState<IDoctorSpecialty[]>(specs);

  const reset = () => {
    setFilterList(specs);
    return;
  };

  const onFilter = (item: string) => {
    if (item.length === 0 || item === "") {
      return reset();
    }

    const existentItems: IDoctorSpecialty[] = [];

    specs.forEach((elm) => {
      const wordExist = elm.key.name.toLowerCase().indexOf(item.toLowerCase());

      if (wordExist !== -1) {
        existentItems.push(elm);
      }
    });

    setFilterList(existentItems);
  };

  const handleSearch = (spec: IDoctorSpecialty) => {
    // Atualiza URL ao trocar especialidade
    searchParams.set("spec", spec.key.name);
    searchParams.delete("page");  // reset paginação
    setSearchParams(searchParams);

    closeModal();

  };

  return (
    <>
      <Modal
        show={modal}
        onHide={() => closeModal}
        backdrop="static"
        keyboard={false}
        className="text-body"
        centered
        scrollable
      >
        <div className="modal-header">
          <h5 className="modal-title">
            <i className="las la-stethoscope me-2 opacity-50"></i>
            Todas as especilidades
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>

        <div className="modal-body bg-light">
          <h6 className="text-muted text-uppercase small">
            Especialidades:
          </h6>

          <div className="position-relative p-1 mb-1">
            <input
              onChange={(e) => onFilter(e.target.value)}
              className="form-control form-control-sm"
              placeholder="Buscar"
            />
          </div>

          <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <ul className="list-group">
              {filterList.map((elm, index) => (
                <label
                  onClick={() => handleSearch(elm)}
                  key={index}
                  role="button"
                  className="list-group-item list-group-item-action"
                >
                  <div className="row justify-content-between g-0">
                    <div className="col">
                      <h6 className="mb-1">{elm.key.name}</h6>
                      <p className="mb-0">
                        {elm.value}{" "}
                        {elm.value === 1 ? "médico" : "médicos"}
                      </p>
                    </div>
                  </div>
                </label>
              ))}
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
};
